// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

export enum AnalysisPanelTabs {
    ThoughtProcessTab = "thoughtProcess",
    SupportingContentTab = "supportingContent",
    CitationTab = "citation"
}
